import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import React from 'react';
import Pheader from "../../Profile_new/Pheader";

const Layout = () => {
  return (
    <>
      <div className="flex flex-col lg:flex-row" style={{ height: "100vh" }}>
        <Sidebar />
        <main className="flex-1 py-4 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </>
  );
}

export default Layout;




// import Sidebar from "./sidebar";

// function RootLayout({ children }) {
//   return (
//     <div className="flex gap-5">
//       <Sidebar />
//       <main className="max-w-5xl flex-1 mx-auto py-4"><Outlet/></main>
//     </div>
//   );
// }

// export default RootLayout;